import { MoreHorizontal } from 'lucide-react';
import { NavLink } from 'react-router-dom';
import { cn } from '../../utils/cn';
import type { NavigationItem } from './navigation';

interface BottomNavProps {
  items: NavigationItem[];
  hasMore: boolean;
  onMore: () => void;
}

export function BottomNav({ items, hasMore, onMore }: BottomNavProps) {
  return (
    <nav
      className="safe-bottom fixed inset-x-0 bottom-0 z-40 border-t border-ink-200 bg-white px-2 py-1.5 lg:hidden"
      aria-label="Điều hướng nhanh"
    >
      <div className="grid grid-cols-5 gap-1">
        {items.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              cn(
                'flex min-h-12 flex-col items-center justify-center gap-1 rounded-md text-[11px] font-medium transition-colors',
                isActive
                  ? 'text-academy-600'
                  : 'text-ink-500 hover:text-ink-900',
              )
            }
          >
            <item.icon className="h-4 w-4" />
            <span className="max-w-full truncate">{item.label}</span>
          </NavLink>
        ))}
        <button
          type="button"
          onClick={onMore}
          disabled={!hasMore}
          className="flex min-h-12 flex-col items-center justify-center gap-1 rounded-md text-[11px] font-medium text-ink-500 transition-colors hover:text-ink-900 disabled:opacity-40"
        >
          <MoreHorizontal className="h-4 w-4" />
          <span>Thêm</span>
        </button>
      </div>
    </nav>
  );
}
